module.exports = require("d3-shape");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-shape"
 ** module id = 149
 ** module chunks = 0 1
 **/